// TRIL-402: client mirror of the server's dmKeys.conversationId — the canonical,
// order-independent id of a 1:1 conversation (sorted pair `min#max`). Lets entry
// points (hovercard/profile "Message", compose) compute the convId from the two
// user ids and deep-link straight into the thread without a round-trip.
export function conversationId(a: string, b: string): string {
  if (!a || !b) throw new Error('conversationId requires two user ids');
  if (a === b) throw new Error('cannot open a conversation with yourself');
  return [a, b].sort().join('#');
}
